import { Stack } from "expo-router";
import TrafficFlowWorklistScreen from "@src/features/traffic-flow/screens/TrafficFlowWorklistScreen.web";

export default function TenantTrafficFlowScreen() {
  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <TrafficFlowWorklistScreen />
    </>
  );
}
